import React, { useMemo, useRef } from "react";
import ArrowRight from "images/icons/arrow-right.inline.svg";

const CourseAccordion = ({
  className,
  header,
  index,
  currentIndex,
  setCurrentIndex,
  children
}) => {
  const contentElement = useRef(null);
  const height = useMemo(
    () =>
      index === currentIndex
        ? `${contentElement.current?.scrollHeight}px`
        : "0px",
    [currentIndex, index]
  );

  return (
    <div className="bg-black-lighter/80 planet:bg-white/10 rounded-xs mb-3">
      <div
        className="flex justify-between items-center px-7 py-6"
        onClick={() => setCurrentIndex(index)}
      >
        <div>
          <span className="h6 !text-white planet:!text-gray-generic">
            Course {index + 1}:
          </span>
          <span className="h6 pl-1 !text-white !font-light">{header}</span>
        </div>
        <ArrowRight
          className={`visible w-3 h-3 stroke-white ${
            index === currentIndex ? "-rotate-90" : "rotate-90"
          }`}
        />
      </div>
      <div
        ref={contentElement}
        className="overflow-hidden transition-all duration-200"
        style={{ height }}
      >
        <div className="w-full flex justify-center px-7">
          <div className="border-b-[0.5px] border-gray-generic/30 w-full" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default CourseAccordion;
